import { SpinnerCenter } from '../primitives/Spinner'

export default function LoadingIndicator() {
  return <SpinnerCenter />
}
